/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityPastebinOrderBy } from './MonitEntityPastebinOrderBy';
import {
    MonitEntityPastebinOrderByFromJSON,
    MonitEntityPastebinOrderByFromJSONTyped,
    MonitEntityPastebinOrderByToJSON,
} from './MonitEntityPastebinOrderBy';

/**
 * 
 * @export
 * @interface MonitGetEntityPastebinQueries
 */
export interface MonitGetEntityPastebinQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityPastebinQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityPastebinQueries
     */
    page_size?: number;
    /**
     * 
     * @type {MonitEntityPastebinOrderBy}
     * @memberof MonitGetEntityPastebinQueries
     */
    order_by?: MonitEntityPastebinOrderBy;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntityPastebinQueries
     */
    desc?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityPastebinQueries
     */
    search?: string;
}

/**
 * Check if a given object implements the MonitGetEntityPastebinQueries interface.
 */
export function instanceOfMonitGetEntityPastebinQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityPastebinQueriesFromJSON(json: any): MonitGetEntityPastebinQueries {
    return MonitGetEntityPastebinQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityPastebinQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityPastebinQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'order_by': !exists(json, 'order_by') ? undefined : MonitEntityPastebinOrderByFromJSON(json['order_by']),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'search': !exists(json, 'search') ? undefined : json['search'],
    };
}

export function MonitGetEntityPastebinQueriesToJSON(value?: MonitGetEntityPastebinQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'order_by': MonitEntityPastebinOrderByToJSON(value.order_by),
        'desc': value.desc,
        'search': value.search,
    };
}

